export default __webpack_public_path__ + "static/media/GPA_Banner_HumanResources.523f6234.png";